'use client';

import { RadialGradientBG } from '@jouzen/ecom-components';

import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

import PopCompareModels from '../_components/shared/PopCompareModels';
import { PopBottom } from './_components/PopBottom';
import { PopHero } from './_components/PopHero';
import { PopHighlights } from './_components/PopHighlights';
import { PopLifestyle } from './_components/PopLifestyle';
import { PopMembership } from './_components/PopMembership';
import { popGradients } from './_components/PopMembership/data/popGradients';
import { PopStyleComparison } from './_components/PopStyleComparison';

const ContentGen3 = (): JSX.Element => {
  const gen4Enabled = useOuraGen4Enabled();

  return (
    <div data-cy="content-pop-ring">
      <RadialGradientBG background="sandstone-300" gradients={popGradients}>
        <PopHero />
        <PopHighlights />
        <PopStyleComparison />
        <PopLifestyle />
      </RadialGradientBG>
      <PopMembership />
      {gen4Enabled && (
        <div className="bg-sandstone-300">
          <PopCompareModels
            copy="pop_compare_models_copy"
            image={{
              localizedAlt: 'pop_gen4_compare_featured_img_alt',
              srcSet: [
                {
                  media: '(max-width: 767px)',
                  src: 'blue-sky/pop/gen4/pop-or4-compare-featured-img.jpg?ar=2:1&fit=crop&crop=focalpoint&fp-x=0.53&fp-y=0.5&fp-z=1.3',
                },
                {
                  media: '(min-width: 768px)',
                  src: 'blue-sky/pop/compare-models-feature.jpg?ar=2:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.63&fp-z=1.6',
                },
              ],
            }}
            title="pop_compare_models_title"
          />
        </div>
      )}
      <PopBottom />
    </div>
  );
};

export default ContentGen3;
